// Import CSS
import '../css/app.css';
import 'photoswipe/dist/photoswipe.css';
import '../css/plugins/photoswipe.css';
import reframe from 'reframe.js'

// Import modules
import { initLazyLoadWithServd } from './modules/lazyLoad';
import { initGalleryWithServd } from './modules/gallery';
import { initCookieBanner } from './modules/cookieBanner';
import { initEmailRevealWithServd } from './modules/emailReveal';
import { initScroll } from './modules/scroll';
import { initServdListeners } from './modules/servdUtils';

// Initialize modules when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize Servd event listeners first
  initServdListeners();
  
  // Initialize lazy loading for images (Servd compatible)
  initLazyLoadWithServd();
  
  // Initialize PhotoSwipe galleries (Servd compatible)
  initGalleryWithServd();
  
  // Initialize cookie banner if present
  if (document.querySelector('.cookie-banner')) {
    initCookieBanner();
  }
  
  // Initialize email reveal buttons (Servd compatible)
  initEmailRevealWithServd();
  
  // Initialize smooth scrolling
  initScroll();
});

// Handle YLE iframe resizing
window.addEventListener('message', (event) => {
  if (event.data?.type === 'YLE-iframe-size-event') {
    const frame = document.getElementById('testFrame');
    if (frame) {
      frame.height = event.data.dimensions.height;
      frame.width = event.data.dimensions.width;
    }
  }
});

window.addEventListener('servd.dynamicloaded', function (e) {
  document.body.classList.remove('loading');
  
  // responsive iframe - reframe all vimeo and youtube iframes
  const initReframe = () => {
    const videoIframes = document.querySelectorAll('iframe[src*="vimeo"], iframe[src*="youtube"], iframe[src*="youtu.be"]');
    if (videoIframes.length > 0) {
      reframe(videoIframes);
    }
  };
  
  initReframe();
  
})